import { globalizeSelectors } from 'framework/globalize/utils/index.js';

const DefaultStatus = { isPending: false, isFailed: false };

export const getStatusOrDefault = (id, state) => state[id] || DefaultStatus;

export default globalizeSelectors(['status_state'], { getStatusOrDefault });
